import src from "IMAGE";
export default { src, width: 394, height: 339 }
